import * as React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";

/**
 * A component for displaying a breadcrumb navigation.
 *
 * @param {object} props
 * @param {{ href?: string, label: string }[]} [props.breadcrumbItems = []]
 * - An array of objects each containing a 'href' and a 'label' property.
 * @returns {JSX.Element} The rendered breadcrumb component.
 */
export const Breadcrumb = ({ breadcrumbItems = [] }) => {
  const navigate = useNavigate();

  const handleClick = (event, href) => {
    event.preventDefault();
    navigate(href);
  };

  return (
    <Breadcrumbs aria-label="breadcrumb">
      {breadcrumbItems.map((item, index) =>
        item.href ? (
          <StyledLink
            key={index}
            href={item.href}
            onClick={(event) => handleClick(event, item.href)}
            underline="hover"
            color="inherit"
          >
            {item.label}
          </StyledLink>
        ) : (
          <StyledTypography aria-current="page">{item.label}</StyledTypography>
        ),
      )}
    </Breadcrumbs>
  );
};

const StyledLink = styled(Link)({
  display: "flex",
  alignItems: "center",
  fontSize: "0.85rem",
});

const StyledTypography = styled(Typography)({
  color: "#3498db",
  display: "flex",
  alignItems: "center",
  fontSize: "0.85rem",
});
